import { renderWithLoader, useForm } from '@metorial/data-hooks';
import { PageHeader } from '@metorial/layout';
import { useCurrentOrganization } from '@metorial/state';
import { Avatar, Input, toast } from '@metorial/ui';
import { Fields, ImageUploadButton, Row, SaveButton, SettingsCard, Stack, useSettingsScope } from './_kit';

// Settings › Organization › General (cloud-spec §7.1).
export let OrganizationSettingsPage = () => {
  let scope = useSettingsScope();
  let organization = useCurrentOrganization();
  let updateOrganization = organization.updateMutator();

  let organizationForm = useForm({
    initialValues: {
      name: organization.data?.name || ''
    },
    enableReinitialize: true,
    onSubmit: async values => {
      let [res] = await updateOrganization.mutate({ name: values.name });
      if (res) toast.success('Organization updated.');
    },
    schema: yup =>
      yup.object({
        name: yup.string().required('Name is required')
      })
  });

  return renderWithLoader({ organization })(({ organization }) => (
    <>
      <PageHeader title="Organization Settings" description="Manage your organization." />

      <Stack>
        <SettingsCard
          title="Organization"
          description="The name and image everyone in your organization sees."
        >
          <Stack $gap={16}>
            <Row $gap={16}>
              <Avatar
                entity={{
                  name: organization.data.name,
                  imageUrl: organization.data.imageUrl
                }}
                size={72}
              />

              <ImageUploadButton
                instanceId={scope.instanceId}
                purpose="organization_image"
                disabled={!scope.isAdmin}
                onUploaded={async imageFileId => {
                  let [res] = await updateOrganization.mutate({ imageFileId });
                  if (res) toast.success('Organization image updated.');
                }}
              />
            </Row>

            <form onSubmit={organizationForm.handleSubmit}>
              <Fields>
                <div>
                  <Input
                    label="Name"
                    disabled={!scope.isAdmin}
                    {...organizationForm.getFieldProps('name')}
                  />
                  <organizationForm.RenderError field="name" />
                </div>

                <Row>
                  <SaveButton
                    loading={updateOrganization.isLoading}
                    success={updateOrganization.isSuccess}
                    disabled={!scope.isAdmin}
                  />
                </Row>
              </Fields>
            </form>
          </Stack>
        </SettingsCard>
      </Stack>
    </>
  ));
};
